import React from "react";
import { FiXCircle } from "@react-icons/all-files/fi/FiXCircle";
import { IconButton, IconButtonProps } from "@chakra-ui/react";

export const DeleteButton = (props: IconButtonProps) => (
  <IconButton size="sm" variant="ghost" icon={<FiXCircle />} {...props} />
);
